import Axios from 'middleware/axiosInstance'
import React, { useEffect, useState } from 'react'
import { Button, Space, Table, message, Card, Typography, Tag } from "antd";
import { useNavigate } from 'react-router-dom';
import Loading from 'layouts/Loading/Loading';
import './LocationSorting.scss';

const { Title, Text } = Typography;

const LocationSorting = () => {
    const navigate = useNavigate();

    const [allLocations, setAllLocations] = useState([]);
    const [hasOrderChanged, setHasOrderChanged] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const getAllLocations = () => {
        Axios.get("/location")
            .then((res) => {
                setAllLocations(res.data || []);
            })
            .catch(err => {
                console.log(err);
                message.error('خطا در بارگذاری لیست شعبه ‌ها');
            });
    };

    useEffect(() => {
        getAllLocations();
    }, []);

    // Handle drag and drop with HTML5 API
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('text/plain', index);
        e.target.style.opacity = '0.5';
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e, dropIndex) => {
        e.preventDefault();
        const dragIndex = parseInt(e.dataTransfer.getData('text/plain'));
        
        if (dragIndex !== dropIndex) {
            const newLocations = [...allLocations];
            const [draggedItem] = newLocations.splice(dragIndex, 1);
            newLocations.splice(dropIndex, 0, draggedItem);
            
            setAllLocations(newLocations);
            setHasOrderChanged(true);
        }
        
        e.target.style.opacity = '1';
    };

    const handleDragEnd = (e) => {
        e.target.style.opacity = '1';
    };

    // Submit new order to backend
    const submitNewOrder = async () => {
        if (!hasOrderChanged) {
            message.info('ترتیب تغییر نکرده است');
            return;
        }

        setIsSubmitting(true);
        try {
            const orderData = allLocations.map((location, index) => ({
                id: location.id,
                order: index
            }));

            const response = await Axios.post('/location/reorder', orderData);
            
            if (response.status === 200) {
                message.success('ترتیب با موفقیت ذخیره شد');
                setHasOrderChanged(false);
            }
        } catch (error) {
            console.error('Error updating order:', error);
            message.error('خطا در ذخیره ترتیب');
        } finally {
            setIsSubmitting(false);
        }
    };

    const columns = [
        {
            title: "ترتیب",
            dataIndex: "order",
            key: "order",
            width: 80,
            render: (_, record, index) => (
                <div className="order-number">
                    {index + 1}
                </div>
            ),
        },
        {
            title: "نام فارسی",
            dataIndex: "name_fa",
            key: "name_fa",
            sorter: (a, b) =>
                a.name_fa > b.name_fa ? 1 : b.name_fa > a.name_fa ? -1 : 0,
            ellipsis: true,
            render: (text, record) => (
                <Space>
                    <span>{text}</span>
                    {record['is_Central_office'] && (
                        <Tag color="gold" style={{ marginRight: 4 }}>مرکزی</Tag>
                    )}
                </Space>
            ),
        },
        {
            title: "نام انگلیسی",
            dataIndex: "name_en",
            key: "name_en",
            ellipsis: true,
        },
        {
            title: "آدرس فارسی",
            dataIndex: "address_fa",
            key: "address_fa",
            ellipsis: true,
        },
        {
            title: "تلفن ثابت",
            dataIndex: "phone1",
            key: "phone1",
            ellipsis: true,
        },
    ];

    return (
        <div className="customized-container location-sorting-page">
            <div className="customized-wrapper">
                <Card>
                    <div className="page-header">
                        <Title level={3}>مرتب‌سازی شعبه ‌ها</Title>
                        <Text type="secondary">
                            برای تغییر ترتیب شعبه ‌ها، روی هر ردیف کلیک کرده و آن را به موقعیت جدید بکشید
                        </Text>
                    </div>

                    <div className="action-buttons">
                        <Space>
                            <Button 
                                type="primary" 
                                onClick={submitNewOrder}
                                loading={isSubmitting}
                                disabled={!hasOrderChanged}
                            >
                                ذخیره ترتیب جدید
                            </Button>
                            <Button 
                                onClick={() => {
                                    setHasOrderChanged(false);
                                    getAllLocations();
                                }}
                            >
                                بازنشانی
                            </Button>
                            <Button 
                                type="default" 
                                onClick={() => navigate('/locations')}
                            >
                                بازگشت به لیست شعبه ‌ها
                            </Button>
                        </Space>
                    </div>

                    {/* Info */}
                    {hasOrderChanged && (
                        <div className="info-alert">
                            <Text type="success">
                                ⚠️ ترتیب تغییر کرده است. برای ذخیره تغییرات روی "ذخیره ترتیب جدید" کلیک کنید.
                            </Text>
                        </div>
                    )}

                    {allLocations.length > 0 ? (
                        <div className="sorting-table">
                            <Table
                                pagination={false}
                                columns={columns}
                                dataSource={allLocations}
                                rowKey="id"
                                onRow={(record, index) => ({
                                    draggable: true,
                                    onDragStart: (e) => handleDragStart(e, index),
                                    onDragOver: (e) => handleDragOver(e),
                                    onDrop: (e) => handleDrop(e, index),
                                    onDragEnd: handleDragEnd,
                                    style: { cursor: 'grab' },
                                    className: 'draggable-row',
                                })}
                            />
                        </div>
                    ) : (
                        <div className="loading-container">
                            <Loading />
                        </div>
                    )}
                </Card>
            </div>
        </div>
    );
};

export default LocationSorting;

